import styled from '@emotion/styled';
import { LeagueLevelStore, LeagueStore } from '@seedlang/stores';
import autobind from 'autobind-decorator';
import CheckIfTrue from 'components/check_if_true';
import InPlaceText from 'components/form/in_place_text';
import InfoTooltip from 'components/info_tooltip';
import Paginator from 'components/paginator';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { Link } from 'react-router';
import Spinner from 'components/spinner';
const Wrapper = styled.div`
  padding: 20px;
`;

@observer
class LeagueLevelEdit extends React.Component {
  componentDidMount() {
    this.getLeagueLevel(this.props.params.leagueLevelId);
    this.getLeagues();
  }

  @autobind getLeagueLevel(id) {
    LeagueLevelStore.getShow({ ids: { leagueLevelId: id } });
  }

  @computed get leagueLevel() {
    return LeagueLevelStore.showData;
  }

  @autobind getLeagues() {
    LeagueStore.getIndex({ filters: { league_level_id: this.props.params.leagueLevelId } , limit: 10});
  }

  @computed get leagues() {
    return LeagueStore.indexData;
  }

  render() {
    if (!this.leagueLevel) return null;
    return (
      <Wrapper>
        <div className='breadcrumbs-wrapper'>
          <div className='breadcrumbs'>
            <Link to='builder.league_levels.index'>League Levels</Link>
            <i className='fa fa-chevron-right' />
            <span>{`${this.leagueLevel.position} - ${this.leagueLevel.name}`}</span>
          </div>
        </div>
        <div className='row'>
          <div className='col-xs-12'>
            <div className='backend-title'>League Level Details</div>
          </div>
        </div>
        <div className='row'>
          <div className='col-xs-6'>
            <fieldset>
              <legend>Name</legend>
                <InPlaceText
                  defaultValue={this.leagueLevel.name}
                  model='league_levels'
                  field='name'
                  id={this.leagueLevel.id}
                />
            </fieldset>
            <fieldset>
              <legend>Position</legend>
              <InPlaceText
                defaultValue={this.leagueLevel.position}
                model='league_levels'
                field='position'
                type='number'
                id={this.leagueLevel.id}
              />
            </fieldset>
          </div>
          <div className='col-xs-6'>
            <fieldset>
              <legend>Promotion Count <InfoTooltip>The number of users that will be promoted from this league level.</InfoTooltip></legend>
              <InPlaceText
                defaultValue={this.leagueLevel.promotionCount}
                model='league_levels'
                field='promotionCount'
                type='number'
                id={this.leagueLevel.id}
              />
            </fieldset>
            <fieldset>
              <legend>Demotion Count <InfoTooltip>The number of users that will be demoted from this league level.</InfoTooltip></legend>
              <InPlaceText
                defaultValue={this.leagueLevel.demotionCount}
                model='league_levels'
                field='demotionCount'
                type='number'
                id={this.leagueLevel.id}
              />
            </fieldset>
          </div>
        </div>
        <div className='backend-title'>Leagues</div>
        <div className='row'>
          <div className='col-xs-6'>
            <fieldset>
              <legend>Active Leagues</legend>
              <div className='form-control-static'>{this.leagueLevel.activeLeaguesCount}</div>
            </fieldset>
          </div>
          <div className='col-xs-6'>
            <fieldset>
              <legend>Active Users</legend>
              <div className='form-control-static'>{this.leagueLevel.activeUsersCount}</div>
            </fieldset>
          </div>
        </div>
        <div className='row' style={{ marginTop: '20px' }}>
          <table className='table-wrapper'>
            <thead>
              <tr>
                <th />
                <th />
                <th>Created At</th>
                <th>End Time</th>
                <th>Active</th>
                <th>Duration</th>
                <th>Highest XP</th>
                <th>Average XP</th>
                <th># Users</th>
              </tr>
            </thead>
            <tbody>
              {
                this.leagues.map((league, index) => {
                  return (
                    <tr key={league.id}>
                      <td>{(index + 1)+(10*(LeagueStore.page-1))}</td>
                      <td>
                        <Link to={{name: 'league.show', params: {leagueId: league.id}}} target='_blank'>
                          <i className='fa fa-external-link fa-block' />
                        </Link>
                      </td>
                      <td>{league.createdAt.formattedDateWithWeekdayYearAndTime}</td>
                      <td>{league.endTime.formattedDateWithYearAndTime}</td>
                      <td>
                        <CheckIfTrue value={league.active} />
                      </td>
                      <td>{league.duration}</td>
                      <td>{league.highestXp} XP</td>
                      <td>{league.averageXp} XP</td>
                      <td>{league.usersCount} users</td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
          <Paginator
            store={LeagueStore}
            filters={{ league_level_id: this.leagueLevel.id }}
            limit={10}
          />
          {
            LeagueStore.requestCounter > 0 &&
              <Spinner />
          }
        </div>
      </Wrapper>
    );
  }
}

export default LeagueLevelEdit;